import {
  jb_highlight_text_item_css_default
} from "./chunk.U7DWSBA4.js";
import {
  fe
} from "./chunk.5J6XSOAX.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  Oe,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n,
  r3 as r2
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-highlight-text-item/jb-highlight-text-item.ts
var JbHighlightTextItem = class extends r {
  async updated(_changedProperties) {
    super.updated(_changedProperties);
    if (_changedProperties.has("svgIcon")) {
      const elm = await this._svgElement;
      elm?.setAttribute("aria-hidden", "true");
    }
  }
  render() {
    return ke`
      ${this.svgIcon ? Oe`${fe(this.svgIcon)}` : D}
      ${this.headline ? ke`<h3>${this.headline}</h3>` : D}
      ${this.subline ? ke`<p>${this.subline}</p>` : D}
    `;
  }
};
JbHighlightTextItem.styles = jb_highlight_text_item_css_default;
__decorateClass([
  n()
], JbHighlightTextItem.prototype, "headline", 2);
__decorateClass([
  n()
], JbHighlightTextItem.prototype, "subline", 2);
__decorateClass([
  n()
], JbHighlightTextItem.prototype, "svgIcon", 2);
__decorateClass([
  r2("svg")
], JbHighlightTextItem.prototype, "_svgElement", 2);
JbHighlightTextItem = __decorateClass([
  customElement("jb-highlight-text-item")
], JbHighlightTextItem);

export {
  JbHighlightTextItem
};
